import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
} from '@angular/core';
import { ModalCloseMethod } from '@rivethealth/data/analytics/account-analytics-events';
import { AnalyticsEventOutput } from '../analytics/common-analytics.service';

const VALUE = '1';

@Component({
  selector: 'confirm',
  templateUrl: './confirm.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ConfirmComponent implements OnInit {
  @Input()
  title = 'Are you sure?';

  @Input()
  hideCancelButton: boolean = false;

  @Input()
  confirmText = 'OK';

  @Input()
  cancelText = 'Cancel';

  @Output()
  confirm = new EventEmitter();

  @Output()
  cancel = new EventEmitter();

  @Input()
  doNotShowKey: string;

  @Input()
  readonly analyticsEvents: {
    confirm?: AnalyticsEventOutput<void>;
  } = {};

  @Input()
  backgroundShading = true;

  @Input()
  outerWidth: string | undefined;

  doNotShowValue = false;

  setDoNotShow() {
    if (this.doNotShowKey && this.doNotShowValue) {
      localStorage.setItem(this.doNotShowKey, VALUE);
    }
  }

  ngOnInit() {
    if (this.doNotShowKey) {
      if (localStorage.getItem(this.doNotShowKey) === VALUE) {
        this.confirm.emit();
      }
    }
  }

  closeMethodRef: { method: ModalCloseMethod } | undefined = undefined;
  setCloseMethod(method: ModalCloseMethod) {
    if (this.closeMethodRef) {
      this.closeMethodRef.method = method;
    }
  }

  setCloseMethodWithConfirmText() {
    this.setCloseMethod(`Click ${this.confirmText.toLowerCase()}`);
  }

  setCloseMethodWithCancelText() {
    this.setCloseMethod(`Click ${this.cancelText.toLowerCase()}`);
  }

  fireAnalytics() {
    this.analyticsEvents.confirm?.();
  }
}
